import { Configuration, ConfigurationObject } from "@shared/interfaces/Configuration";

const { VITE_APP_ENV = "dev" } = import.meta.env;

// `csrfCookieName` must match the API's NODE_ENV suffix exactly: the production cookie is scoped
// to the parent domain, so it is also visible on the qa/uat subdomains.
const dev: Configuration = {
  env: VITE_APP_ENV,
  baseApiUrl: "http://localhost:4000/api/v1/",
  csrfCookieName: "XSRF-TOKEN_development",
};

const qa: Configuration = {
  ...dev,
  baseApiUrl: "https://api.qa.prisonology.com/api/v1/",
  csrfCookieName: "XSRF-TOKEN_qa",
};

const uat: Configuration = {
  ...dev,
  baseApiUrl: "https://api.uat.prisonology.com/api/v1/",
  csrfCookieName: "XSRF-TOKEN_uat",
};

const production: Configuration = {
  ...dev,
  baseApiUrl: "https://api.prisonology.com/api/v1/",
  csrfCookieName: "XSRF-TOKEN",
};

const config: ConfigurationObject = {
  dev,
  qa,
  uat,
  production,
};

const configElement: Configuration = config[VITE_APP_ENV];
export default configElement;
